import { startTransition, useState } from 'react';

import { UserCommunication } from '@this+that/models';

export enum HandlerButton {
  REPLY = 'reply',
  REPLY_ALL = 'reply_all',
  FORWARD = 'forward',
  UNSELECTED = 'unselected',
}

export const useViewMessageComposerHandler = () => {
  const [selectedHandlerButton, setSelectedHandlerButton] =
    useState<HandlerButton>(HandlerButton.UNSELECTED);
  const [selectedMessage, setSelectedMessage] =
    useState<UserCommunication | null>(null);
  const [aiAssisted, setAiAssisted] = useState(false);

  const onSelectReply = (message: UserCommunication) => {
    // startTransition keeps the parent modal visible while the composer's lazy chunks load on first open
    startTransition(() => {
      setSelectedMessage(message);
      setSelectedHandlerButton(HandlerButton.REPLY);
      setAiAssisted(false);
    });
  };

  const onSelectReplyAll = (message: UserCommunication) => {
    // startTransition keeps the parent modal visible while the composer's lazy chunks load on first open
    startTransition(() => {
      setSelectedMessage(message);
      setSelectedHandlerButton(HandlerButton.REPLY_ALL);
      setAiAssisted(false);
    });
  };

  const onSelectForward = (message: UserCommunication) => {
    // startTransition keeps the parent modal visible while the composer's lazy chunks load on first open
    startTransition(() => {
      setSelectedMessage(message);
      setSelectedHandlerButton(HandlerButton.FORWARD);
      setAiAssisted(false);
    });
  };

  const onResetHandler = () => {
    setSelectedMessage(null);
    setSelectedHandlerButton(HandlerButton.UNSELECTED);
    setAiAssisted(false);
  };

  return {
    onSelectReply,
    onSelectReplyAll,
    onSelectForward,
    onResetHandler,
    selectedHandlerButton,
    selectedMessage,
    aiAssisted,
  };
};
